import script from "./hct-screen.vue?vue&type=script&setup=true&lang=js"
export * from "./hct-screen.vue?vue&type=script&setup=true&lang=js"

import "./hct-screen.vue?vue&type=style&index=0&id=7a12fa6f&lang=scss"
import "./hct-screen.vue?vue&type=style&index=1&id=7a12fa6f&scoped=true&lang=scss"

import exportComponent from "E:\\a-project\\hct-element\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7a12fa6f"]])

export default __exports__